import {
  Component,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { ParseService } from 'apps/account/src/account-shared/services/parse.service';
import { IdentityService } from 'account-hybrid/core/authentication/services/identity.service';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Curation image-details panel: rotate image + staff-gated Caption/Quote textareas.
 * Reads/writes the same shared `guest` object by reference (rotate + textareas mutate
 * guest.poststay.* in place); the host's Done/Cancel footer commits or rolls back.
 */
@Component({
    selector: 'ft-curation-image-details-ng',
    imports: [TranslateModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-curation-image-details.component.html'
})
export class FtCurationImageDetailsComponent {
    /** The curation guest/story — the SAME object the AngularJS directive scope holds. */
    readonly guest = input<any>();

    private readonly parse: any = inject(ParseService);

    /** `identity` is the Angular `IdentityService` — the same service the v1
     * `ng-if="identity.isFliptoStaff()"` staff-gate resolves through. */
    protected readonly identity = inject(IdentityService);

    /** v1 `scope.changeRotateDegree` — rotate the shared photo 90° (savePhotoDetails reads it). */
    protected changeRotateDegree(): void {
        if (!this.guest()?.poststay?.photo) return;
        this.guest().poststay.photo.degrees = (this.guest().poststay.photo.degrees || 0) + 90;
    }

    /** v1 `ng-model="guest.poststay.photo.caption"` — mutate the shared object in place. */
    protected setCaption(value: string): void {
        if (!this.guest()?.poststay?.photo) return;
        this.guest().poststay.photo.caption = value;
    }

    /** v1 `ng-model="guest.poststay.quote.notesPositive"` — AngularJS ng-model auto-vivifies
     * the intermediate `quote` object on assign, so reproduce that (savePhotoDetails then
     * reads `guest.poststay.quote.notesPositive`). */
    protected setQuote(value: string): void {
        if (!this.guest()?.poststay) return;
        this.guest().poststay.quote = this.guest().poststay.quote || {};
        this.guest().poststay.quote.notesPositive = value;
    }

    // --- pure helpers, verbatim from curationModal.directive.js ---

    protected isInvitee(): boolean {
        const guest = this.guest();
        return guest && this.parse.bool(guest.isInvitee);
    }

    protected hasQuote(): boolean {
        const guest = this.guest();
        return (
            guest &&
            guest.poststay &&
            guest.poststay.quote &&
            guest.poststay.quote.notesPositive !== undefined
        );
    }
}
